import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import WhatsAppFloat from "./WhatsAppFloat";
import FootwearLoader from "./FootwearLoader";
import { useStore } from "@/store/StoreContext";

function MarketingScripts() {
  const { settings } = useStore();
  useEffect(() => {
    const m = settings?.marketing || {};
    const head = document.head;
    const add = (id, html) => {
      if (document.getElementById(id)) return;
      const tpl = document.createElement("template");
      tpl.innerHTML = html.trim();
      tpl.content.childNodes.forEach((n) => {
        const el = n.cloneNode(true);
        if (el.nodeType === 1 && el.tagName === "SCRIPT") {
          const s = document.createElement("script");
          [...el.attributes].forEach((a) => s.setAttribute(a.name, a.value));
          s.text = el.textContent;
          s.id = id;
          head.appendChild(s);
        } else if (el.nodeType === 1) { el.id = id; head.appendChild(el); }
      });
    };
    if (m.google_verification) add("tq-gverify", `<meta name="google-site-verification" content="${m.google_verification}">`);
    if (m.meta_verification) add("tq-mverify", `<meta name="facebook-domain-verification" content="${m.meta_verification}">`);
    if (m.ga4_id) {
      add("tq-ga4a", `<script async src="https://www.googletagmanager.com/gtag/js?id=${m.ga4_id}"></script>`);
      add("tq-ga4b", `<script>window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag('js',new Date());gtag('config','${m.ga4_id}');</script>`);
    }
    if (m.gtm_id) {
      add("tq-gtm", `<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${m.gtm_id}');</script>`);
    }
    if (m.google_ads_id) {
      if (!m.ga4_id) {
        add("tq-gads-a", `<script async src="https://www.googletagmanager.com/gtag/js?id=${m.google_ads_id}"></script>`);
        add("tq-gads-b", `<script>window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag('js',new Date());gtag('config','${m.google_ads_id}');</script>`);
      }
      if (m.google_ads_label) window.__tqAds = { id: m.google_ads_id, label: m.google_ads_label };
    }
    if (m.meta_pixel_id) {
      add("tq-fbp", `<script>!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${m.meta_pixel_id}');fbq('track','PageView');</script>`);
    }
    if (m.clarity_id) {
      add("tq-clarity", `<script>(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script","${m.clarity_id}");</script>`);
    }
    if (m.custom_head) add("tq-custom-head", m.custom_head);
  }, [settings]);
  return null;
}

export default function Layout() {
  const { pathname } = useLocation();
  const { settings } = useStore();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  if (!settings) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFFFFF]" data-testid="app-initial-loader">
        <FootwearLoader />
      </div>
    );
  }
  return (
    <div className="min-h-screen flex flex-col bg-[#FFFFFF]">
      <MarketingScripts />
      <Header />
      <main className="flex-1 pb-16 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <WhatsAppFloat />
    </div>
  );
}
